<template>
  <div class="c-group">
    <filters placeholder="请输入计划名称" :dataSource="dataSource" @on-change="filterData" @on-search="searchFilterData" />
    <div class="c-control-btn">
      <div>
        <ElButton type="primary" @click="openNewEntry">新建{{ open }}</ElButton>
        <Dropdown class="c-btn-group" @on-click="betch" style="margin: 0 10px">
          <ElButton>
            批量操作
            <Icon type="ios-arrow-down"></Icon>
          </ElButton>
          <DropdownMenu slot="list">
            <DropdownItem :name="1">启用</DropdownItem>
            <DropdownItem :name="0">暂停</DropdownItem>
            <DropdownItem :name="-1">删除</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Tag v-if="projectId > 0" color="primary" closable @on-close="clearProjectFilter"> 1个项目中的计划</Tag>
      </div>
      <div>
        <ElButton @click="modalColumn = true">自定义列</ElButton>
      </div>
    </div>
    <!-- 表格列表 -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <ad-table
          ref="adTable"
          :value="spining"
          :data="adList"
          :columns="tableCol"
          :media="mediaVal"
          :height="tableHeight"
          @on-sort="sortTable"
          @on-refresh="getData"
          @on-project-filter="projectFilter"
          @header-dragend="headerDragend"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" @on-select="selectColumn" />
  </div>
</template>
<script>
import mixin from './mixin'
import { isArray } from '@/common/js/utils'
import { invenType, statusData } from './data/constant.js'
import { TOUTIAO_AD } from '../data/toutiao_ad_column'
import { queryMediaAdList } from '@/api/convert.model'
import { adGames, adAccount, adPtom } from '@/api/common.model'
import Filters from './components/ad-filter.vue'
import CustomColumn from '@/components/converter/custom-column.vue'
import adTable from './components/ad-table.vue'

export default {
  name: 'ToutiaoAd',
  mixins: [mixin],
  components: { Filters, CustomColumn, adTable },
  computed: {
    mediaVal() {
      return 10
    },
    // 存local用户自定义列
    custom() {
      return 'toutiaoAd'
    },
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    },
    open() {
      return '计划'
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => `${met.key}${met.width ? `|${met.width}` : ''}`)
        this.setCustomStorage(`${this.custom}CustomColumn`, show)
        this.$nextTick(() => {
          this.$refs.adTable && this.$refs.adTable.doLayout()
        })
      },
      deep: true
    },
    projectId: {
      handler(nVal, oVal) {
        if (nVal !== oVal) {
          this.getData()
        }
      },
      deep: true
    },
    $route(to, from) {
      if (this.$router.currentRoute.query.accountId) {
        this.accountId = this.$router.currentRoute.query.accountId
        this.projectId = this.$router.currentRoute.query.projectId
      }
    }
  },
  methods: {
    // 自定义列 全选
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter((ret) => ret.type === type)
      data.forEach((ret) => {
        this.$set(ret, 'show', show)
      })
    },
    getData(filter) {
      let params = {
        mediaId: this.mediaVal,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order
      }

      if (filter) params = Object.assign(params, filter)
      else if (this.params) params = Object.assign(this.params, params)

      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))

      // 投放计划id(临时参数)
      if (!params.adAccountId) params = Object.assign(params, { adAccountId: this.accountId })
      if (this.projectId) params = Object.assign(params, { mediaProjectId: this.projectId })

      // 请求数据
      this.spining = true
      queryMediaAdList(params).then((data) => {
        this.spining = false
        if (data && data.list && data.page_info) {
          // eslint-disable-next-line
          const { total_number } = data.page_info
          this.adList = data.list.map((ret) => {
            ret.optStatus = ret.optStatus === 1
            ret.bid = ret.bid === 0 ? '-' : ret.bid
            ret.budgetFlag = parseInt(ret.budget) > 0 ? 1 : 0
            ret.roiRatio = ret.deepConversionType === '付费ROI' || ret.ocpxActionType === '付费ROI' ? ret.roiRatio : '-'
            return ret
          })
          // eslint-disable-next-line
          this.total = total_number ? total_number : 0
          this.$nextTick(() => {
            this.$refs.adTable && this.$refs.adTable.doLayout()
          })
        }
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size)
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    betch(type) {
      if ([1, 0, -1].includes(type)) {
        this.$refs.adTable.changeBetch(type)
      }
    },
    projectFilter(row) {
      this.accountId = row.accountId
      this.projectId = row.projectId
    },
    clearProjectFilter() {
      this.accountId = ''
      this.projectId = ''
    },
    preload() {
      Promise.all([adGames({ type: 1 }), adAccount({ authFlag: 1, mediaId: 10 }), adPtom({ authFlag: 1 })])
        .then((data) => {
          const [gameData, accountData, opData] = data
          isArray(opData) && (this.dataSource.opData = opData.map((op) => ({ ...op, id: op.opId })))
          isArray(gameData) && (this.dataSource.gameData = gameData)
          isArray(accountData) && (this.dataSource.accountData = accountData)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  data() {
    return {
      tableHeight: 330,
      accountId: this.$router.currentRoute.query.accountId,
      projectId: this.$router.currentRoute.query.projectId,
      modalColumn: false, // 自定义列
      spining: null, // 表格数据加载
      adList: [], // 广告列表
      columns: [],
      invenType: invenType,
      dataSource: {
        opData: [],
        gameData: [],
        accountData: [],
        inventoryData: invenType.map((ret) => {
          return { id: ret.key, name: ret.value }
        }),
        statusData: statusData,
        autoRuleData: [
          {
            id: 0,
            name: '无规则'
          },
          {
            id: 1,
            name: '有规则'
          }
        ]
      }
    }
  },
  created() {
    this.preload()
    const columns = TOUTIAO_AD
    const shows = this.getCustomStorage(`${this.custom}CustomColumn`)
    // 表格列数据
    // 同步本地存储自定义列
    if (shows.length) {
      this.columns = columns
        .sort((a, b) => {
          const idxA = shows.findIndex((ret) => ret.includes(a.key))
          const idxB = shows.findIndex((ret) => ret.includes(b.key))
          const sortA = idxA < 0 ? idxA : shows.length - idxA
          const sortB = idxB < 0 ? idxB : shows.length - idxB
          return sortB - sortA
        })
        .map((ret) => {
          const shifRet = shows.filter((met) => met && met.includes('|') && met.includes(ret.key)).shift()
          ret.show = !shows
            .filter((met) => met)
            .map((met) => (met.includes('|') ? met.split('|').shift() : met))
            .includes(ret.key)
          shifRet && (ret.width = parseInt(Number(shifRet.split('|').pop() || '')))
          return ret
        })
    } else {
      this.columns = [...columns]
    }
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-group {
  .c-control-btn {
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;

    .ivu-tag {
      margin: 0 !important;
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
